import { SVGProps } from "react";
import { Icon, IconProps } from "@chakra-ui/react";

export function ExclamationMarkIcon(props: IconProps) {
  return <Icon as={ExclamationMarkIconComponent} color="gray.600" boxSize="20px" {...props} />;
}

function ExclamationMarkIconComponent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_5124_17832)">
        <path
          d="M9.9987 1.66634C5.39633 1.66634 1.66537 5.3973 1.66537 9.99968C1.66537 14.602 5.39633 18.333 9.9987 18.333C14.6011 18.333 18.332 14.602 18.332 9.99968C18.332 5.3973 14.6011 1.66634 9.9987 1.66634Z"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.99219 6.66699L9.99219 10.0003"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.99219 13.333L10.0005 13.333"
          stroke="currentColor"
          strokeWidth="1.6"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_5124_17832">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(20 20) rotate(-180)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
